<div style="border:1px solid;background-color: white; position: relative;" id="jobcardprint">
  @if (ActiveDocumentVersion) {
    <div
      style="position: absolute; right: 5px; top: 5px; font-size: 10px; text-align: right; line-height: 1.2;">
      <span>{{ActiveDocumentVersion.FormatNo}}, Rev No. {{ActiveDocumentVersion.VersionNo}}</span>
    </div>
  }
  <div style="text-transform: uppercase; text-align: center; color: black; border: 1px solid black;">
    <p style="font-size: 15px;"><b>{{this.Company.CompanyName}}</b></p>
    <p style="font-size: 10px;"><b>Head Office: </b>{{this.Company.HeadOfficeAddress}}</p>
    <p style="font-size: 10px;"><b>Factory Address: </b>{{this.Company.FactoryAddress}}</p>
  </div>
  <div style="text-transform: uppercase; font-size: 13px; text-align: center; color: black; border: 1px solid black;">
    <b>Software Generated Job Card ({{MixingName}})</b>
  </div>
  @if (Production) {
    <nz-descriptions nzBordered nzSize="small" [nzColumn]="2" style="border: 1px solid black;">
      <nz-descriptions-item nzTitle="WorkPlan No."><b>{{Production.WorkPlanNumber}}</b></nz-descriptions-item>
      <nz-descriptions-item nzTitle="Sale Order No."><b>{{Production.SaleOrderNumber}}</b></nz-descriptions-item>
      <nz-descriptions-item
        nzTitle="Formulation Code"><b>{{Production.SaleFormulationCode}}</b></nz-descriptions-item>
        <nz-descriptions-item nzTitle="Application"><b>{{Production.Category}}</b></nz-descriptions-item>
        <nz-descriptions-item nzTitle="Colour Name/Code"><b>{{Production?.SaleOrderProduction?.ColorName}} /
        {{Production?.SaleOrderProduction?.ColorCode}}</b></nz-descriptions-item>
        <nz-descriptions-item nzTitle="Grain Name/Code"><b>{{Production?.SaleOrderProduction?.GrainName}} /
        {{Production?.SaleOrderProduction?.GrainCode}}</b></nz-descriptions-item>
        <nz-descriptions-item
          nzTitle="PRD MTR(Incl. Extra {{Production?.SaleOrderProduction?.ExtraProduction}}%)"><b>{{TotalProductionQty}}</b></nz-descriptions-item>
          <nz-descriptions-item nzTitle="Customer"><b>{{Production?.CustomerName}}</b></nz-descriptions-item>
          <nz-descriptions-item
            nzTitle="Inspected By"><b>{{Production?.PreInspectionCompletedBy}}</b></nz-descriptions-item>
            <nz-descriptions-item nzTitle="Inspected Date & Time"><b>{{Production?.PreInspectionCompletedOn |
            DatetimeConverter}}</b></nz-descriptions-item>
            <nz-descriptions-item nzTitle="Operator Name & Mobile No.">{{""}}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="All Paste Ready Date & Time">{{""}}</nz-descriptions-item>
            <nz-descriptions-item
            nzTitle="Supervisor Name">{{this.Production.SaleOrderProduction.InspectionSaleFormulationCode.ShiftSupervisorWorkerName}}</nz-descriptions-item>
          </nz-descriptions>
        }
        @if (Production) {
          <div nz-row [nzGutter]="24" style="margin: 0px 0px;">
            @for (i of Production.SaleOrderProduction.InspectionFormulationMixing; track i) {
              <div nz-col [nzSpan]="24">
                <nz-table nzSize="small" [nzData]="['']" #basicTable1 nzBordered nzShowPagination="false"
                  style="margin-left: 0; margin-right:0;font-weight: bolder;">
                  <thead>
                    <tr style="text-transform: uppercase; font-size: 16px; text-align: center; color: black;">
                      <td colspan="4" style="border: 1px solid black;">
                        <b>{{i.MixingName}}</b>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td width="40%" style="text-align:left; border: 1px solid;font-size: 14px;"><b>Item Name</b>
                    </td>
                    <td style="text-align:center; border: 1px solid;font-size: 14px;" width="15%"><b>QTY</b>
                  </td>
                  <td style="text-align:center; border: 1px solid;font-size: 14px;" width="15%"><b> SC QTY</b>
                </td>
                <td style="text-align:center; border: 1px solid;font-size: 14px;width: 30%;" width="30%">
                  <b>Additional
                  QTY</b>
                </td>
              </tr>
              @for (data of i.MixingRawMaterial; track data; let i = $index) {
                <tr>
                  <td width="40%" style="border: 1px solid ;text-align: left;font-size: 14px;">{{
                    data.ProductName
                  }}@if (data.IsPigment) {<b> (Pigment)</b>}@if (data.IsBaseMaterial) {<b> (Base)</b>}@if (data.Perishable) {<b> (Perishable)</b>}</td>
                  <td width="15%" style="text-align:center; border:1px solid;font-size: 14px;">{{ data.Quantity
                  }}</td>
                  <td width="15%" style="text-align:center; border:1px solid;font-size: 14px;">{{ data.Scquantity
                  }}</td>
                  <td width="30%" style="text-align:center; border:1px solid;font-size: 14px;"></td>
                </tr>
              }
              @for (number of [].constructor(2); track number) {
                <tr>
                  <td style="text-align:center; border:1px solid;height: 35px;"></td>
                  <td style="text-align:center; border:1px solid;"></td>
                  <td style="text-align:center; border:1px solid;"></td>
                  <td style="text-align:center; border:1px solid;"></td>
                </tr>
              }
            </tbody>
            <tfoot>
              <tr>
                <td width="60%" style="text-align:left; border: 1px solid;font-size: 14px;"><b> Total Paste
                </b></td>
                <td style="text-align:center; border: 1px solid;font-size: 14px;">
                  <b>{{this.totalCalculatedQuantities[i.MixingName.toLowerCase()]}} Kgs</b>
                </td>
                <td style="text-align:center; border: 1px solid;font-size: 14px;">
                  <b>{{this.totalCalculatedSCQuantities[i.MixingName.toLowerCase()]}} Kgs</b>
                </td>
                <td style="text-align:center; border: 1px solid"></td>
              </tr>
              @if (hasPigment(i.MixingRawMaterial)) {
                <tr>
                  <td width="60%" style="text-align:left; border: 1px solid;font-size: 14px;"><b> Total Paste + Pigment
                  </b></td>
                  <td style="text-align:center; border: 1px solid;font-size: 14px;">
                    <b>{{this.totalAllQuantities[i.MixingName.toLowerCase()]}} Kgs</b>
                  </td>
                  <td style="text-align:center; border: 1px solid;font-size: 14px;">
                    <b>{{this.totalAllSCQuantities[i.MixingName.toLowerCase()]}} Kgs</b>
                  </td>
                  <td style="text-align:center; border: 1px solid"></td>
                </tr>
              }
            </tfoot>
          </nz-table>
        </div>
      }
      <!-- Only show Fabric details if mixing is relevant or generally? -->
      <!-- User said "per mixing print", usually Fabric is separate or part of one mixing? -->
      <!-- In the original code, Fabric is shown after the loop. -->
      <!-- In this case, since we filter the loop, if we keep Fabric outside it will always show. -->
      <!-- Let's keep it but maybe it's only relevant for certain mixings? -->
      <!-- For now I will hide Fabric and Total Weights if we are printing specific mixing, or should I incldue them? -->
      <!-- The user's request "per mixing" suggests they want to print just that mixing instructions for the operator. -->
      <!-- I'll omit Fabric and Total Weights summary for now as they seem global. -->
    </div>
  }



  <app-print-footer [audience]="'internal'"></app-print-footer>
</div>
<app-loader></app-loader>